import React from 'react';
import { useNavigate } from 'react-router-dom';
import { responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize } from '../../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import TitleLogo_Web from '../../../assets/icon/sitter/mobile/title_logo.svg';
import TitleLogo_Mobile from '../../../assets/icon/sitter/mobile/title_logo.svg';
import MenuIcon_Mobile from '../../../assets/icon/partner/menu.svg';

const HeaderBrowserComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();
    const navigate = useNavigate();
    
    const pressMain = () => {
        navigate("/")
    }
    const onMenu = () => {
        navigate("/sitter/menu");
    }
  
    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.header_Web}>
                        <img src={TitleLogo_Web} style={styles.titleLogo_Web} alt="로고" onClick={() => pressMain()} />
                        <p style={styles.menuTxt_Web} onClick={() => pressMain()} >우주펫 소개</p>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.header_Mobile}>
                        <img src={TitleLogo_Mobile} style={styles.titleLogo_Mobile} alt="로고" onClick={() => pressMain()} />
                        <img src={MenuIcon_Mobile} alt="메뉴" style={styles.menu_Mobile} onClick={() => onMenu()} />
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    header_Web: { height: responsiveImageSize(70, 100), maxWidth: "100%", backgroundColor: "white", display: "flex", top: 0, position: "fixed", zIndex: 1000, boxSizing: "border-box", left: "50%", transform: "translate(-50%, 0)", width: "100%", justifyContent: "space-between", flexDirection: "row", alignItems: "center", paddingTop: responsivePaddingVertical(4, 30), paddingBottom: responsivePaddingVertical(4, 34), cursor: "pointer", paddingLeft: responsivePaddingHorizontal(24, 180), paddingRight: responsivePaddingHorizontal(24, 180) },
    titleLogo_Web: { width: responsiveImageSize(96, 227), height: responsiveImageSize(30, 72), cursor: "pointer" },
    menuTxt_Web: { color: "#62686D", fontFamily: "Pretendard", fontWeight: "600", fontSize: "26px", lineHeight: "120%", letterSpacing: "-2%", marginRight: "50px" },
    
    header_Mobile: { height: responsiveImageSize(70, 100), backgroundColor: "white", display: "flex", top: 0, left: 0, position: "fixed", paddingTop: responsivePaddingVertical(4, 30), paddingBottom: responsivePaddingVertical(4, 34), cursor: "pointer", paddingLeft: responsivePaddingHorizontal(24, 180), paddingRight: responsivePaddingHorizontal(24, 180), width: "100%", minWidth:"320px", zIndex: 1000, boxSizing: "border-box", flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
    titleLogo_Mobile: { width: responsiveImageSize(96, 227), height: responsiveImageSize(30, 72), cursor: "pointer" },
    menu_Mobile: { width: responsiveImageSize(30, 40), height: responsiveImageSize(30, 40), cursor: "pointer" }
});

export default HeaderBrowserComponent;